import {FC} from 'react';
import {useFormContext, useWatch} from 'react-hook-form';
import {TextFieldElement} from 'react-hook-form-mui';
import {Box, Stack} from '@mui/material';

import {
  FileInput,
  imageFileTypes,
  TranslateFieldButton,
} from '@shared/components';
import {resolveEnglishText} from '@shared/helpers';
import {TranslationDict} from '@shared/types';
import {dummyFunc} from '@shared/utils';
import {openAddTranslationsDialog} from '@widgets/common/AddTranslationsDialog';
import {FormValues} from './v8nSchema';

interface Props {
  existingLogoUrl?: string;
  nameTranslations: TranslationDict;
  onNameTranslationsChange: (translations: TranslationDict) => void;
}

export const FormFields: FC<Props> = ({
  existingLogoUrl,
  nameTranslations,
  onNameTranslationsChange,
}) => {
  const {
    control,
    setValue,
    formState: {dirtyFields},
  } = useFormContext<FormValues>();
  const currentName = useWatch({control, name: 'name'});

  return (
    <Stack spacing={6} mt={2}>
      <TextFieldElement name="slug" label="Slug" control={control} autoFocus />

      <Box display="flex" alignItems="center" gap={2}>
        <TextFieldElement
          name="name"
          label="Name"
          control={control}
          sx={{flex: 1}}
        />
        <TranslateFieldButton
          onClick={() => {
            void openAddTranslationsDialog({
              fieldName: 'Name',
              initialTranslations: nameTranslations,
              enTrans: resolveEnglishText(
                nameTranslations,
                currentName,
                !!dirtyFields.name,
              ),
            })
              .then((translations: TranslationDict) => {
                setValue('name', translations.en ?? currentName);
                onNameTranslationsChange(translations);
                return;
              })
              .catch(dummyFunc);
          }}
        />
      </Box>

      <FileInput
        fieldName="logoFile"
        acceptedFileTypes={imageFileTypes}
        existingFileUrl={existingLogoUrl}
      />
    </Stack>
  );
};
